import React from 'react';

import static_loader from '../../../images/static_loader.svg';

import { FOHImage } from '../../ingredients';

export const FOHStaticLoaderIcon = (props: any) => (
  <FOHImage
    source={{ uri: static_loader }}
    style={{ width: 16, height: 16, ...props?.style }}
  />
);
